<template>
    <div
        class="pdf-viewer"
        :class="mobile ? 'mobile-viewer' : ''"
    >
        <div v-for="i in numPages" :key="i">
            <VuePdf
                ref="pdf"
                :src="src"
                :page="i"
                @page-loaded="i"
                @error="error"
                @num-pages="1"
            />
        </div>
    </div>
</template>

<script>
    import VuePdf from 'vue-pdf';
    import {
        isMobile
    } from 'mobile-device-detect';

    export default {
        name: 'pdf-viewer',
        components: {
            VuePdf
        },
        props: {
          src: {
            type: String,
            default: '',
            required: true
          }
        },
        data() {
            return {
                mobile: isMobile,
                pdfContent: null,
                numPages: undefined
            };
        },
        mounted() {
            VuePdf.createLoadingTask(this.src).promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        methods: {
            error(err) {
                return err;
            }
        }
    };
</script>

<style scoped>
    .pdf-viewer {
        border: solid 2px var(--color-alto-gray);
        height: 100%;
        margin: 0 auto;
        max-width: 1200px;
        position: relative;

        > span {
            display: block !important;
        }

        .loading {
            @mixin position absolute, 50%, 5%, 0, 50%;
            background-color: color-mod(var(--color-black) alpha(75%));
            border-radius: 50%;
            color: var(--color-white);
            height: 100px;
            line-height: 5;
            padding: 10px;
            text-align: center;
            transform: translate3d(-50%, -50%, 0);
            width: 100px;
            z-index: var(--z-index-base);
        }
    }
</style>
